import styled from 'styled-components';
import { Button, Row } from 'antd';
import { Box, Text } from 'atoms';
import { DatePickers } from 'utils/commonStyled';

export const PageContainer = styled(Box)`
	width: 90%;
	margin: 0 auto;
`;

export const HeaderContainer = styled(Box)`
	margin-bottom: 1.5rem;
`;

export const FormTitle = styled(Text)`
	font-size: 24px;
	font-weight: 600;
	color: #1c1c1c;
	margin-bottom: 4px;
	display: block;
`;

export const FormSubtitle = styled(Text)`
	font-size: 14px;
	color: #707070;
	display: block;
`;

export const FormContainer = styled(Box)`
	background: #fff;
	border-radius: 8px;
	padding: 2rem 2rem;
	box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
	margin: 0 auto;
	max-width: 1200px;
`;

export const FormRow = styled(Row)`
	margin-bottom: 1rem;

	&:last-child {
		margin-bottom: 0;
	}
`;

export const ButtonContainer = styled(Box)`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	margin-top: 1.25rem;
`;

export const SubmitButton = styled(Button)`
	background-color: #18405d;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 8px 24px;
	height: auto;
	font-size: 15px;
	font-weight: 500;

	&:hover {
		background-color: #153e60;
		color: #fff;
	}
`;

export const CancelButton = styled(Button)`
	background: #fff;
	color: #595959;
	border: 1px solid #d9d9d9;
	border-radius: 4px;
	padding: 8px 24px;
	height: auto;
	font-size: 15px;
	font-weight: 500;

	&:hover {
		background: #f5f5f5;
		color: #595959;
		border-color: #d9d9d9;
	}
`;

export const StyledDatePicker = styled(DatePickers)`
	width: 100%;
`;

export const FileUploadButton = styled(Button)`
	background-color: #18405d;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 8px 20px;
	height: auto;
	font-size: 14px;
	font-weight: 500;

	&:hover {
		background-color: #153e60;
		color: #fff;
	}
`;

export const UploadedFileContainer = styled(Box)`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 12px;
	background-color: #f5f5f5;
	border: 1px solid #d9d9d9;
	border-radius: 4px;
	margin-top: 8px;
`;

export const FileInfo = styled(Box)`
	display: flex;
	align-items: center;
	gap: 8px;
	flex: 1;
`;

export const FileIcon = styled(Box)`
	color: #ff4d4f;
	font-size: 20px;
`;

export const FileDetails = styled(Box)`
	display: flex;
	flex-direction: column;
`;

export const FileName = styled(Text)`
	font-size: 14px;
	color: #262626;
	font-weight: 500;
`;

export const FileSize = styled(Text)`
	font-size: 12px;
	color: #8c8c8c;
`;

export const RemoveButton = styled(Button)`
	border: none;
	background: transparent;
	color: #8c8c8c;
	padding: 0;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;

	&:hover {
		color: #ff4d4f;
		background: transparent;
	}
`;

export const ErrorMessage = styled(Text)`
	color: #ff4d4f;
	font-size: 12px;
	margin-top: 4px;
	display: block;
`;

export const FileUploadContainer = styled(Box)`
	.error-message {
		color: #ff4d4f;
		font-size: 12px;
		margin-top: 4px;
		display: block;
	}
`;
